export default __webpack_public_path__ + "static/media/lato-bolditalic.0b525586.woff2";